import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login/index.vue'),
    meta: { title: '登录', noAuth: true }
  },
  {
    path: '/',
    redirect: () => (store.getters.isLoggedIn ? '/dashboard' : '/login')
  },
  {
    path: '/',
    component: () => import('@/components/Layout/index.vue'),
    redirect: '/dashboard',
    meta: { requiresAuth: true },
    children: [
      { path: 'dashboard', name: 'Dashboard', component: () => import('@/views/Dashboard/index.vue'), meta: { title: '首页' } },
      { path: 'health', redirect: '/health/workbench' },
      {
        path: 'health/workbench',
        name: 'HealthWorkbench',
        component: () => import('@/views/Health/HealthWorkbench.vue'),
        meta: { title: '健康数据工作台', auraIosShell: true }
      },
      { path: 'health/blood-pressure', redirect: '/health/workbench' },
      { path: 'health/blood-glucose', redirect: '/health/workbench' },
      { path: 'health/blood-lipid', redirect: '/health/workbench' },
      { path: 'health/blood-oxygen', redirect: '/health/workbench' },
      { path: 'health/bmi', redirect: '/health/workbench' },
      { path: 'health/sleep', redirect: '/health/workbench' },
      { path: 'health/exercise', redirect: '/health/workbench' },
      { path: 'health/condition', redirect: '/health/workbench' },
      { path: 'health/medication', redirect: '/health/workbench' },
      { path: 'health/kidney', redirect: '/health/workbench' },
      { path: 'health/liver', redirect: '/health/workbench' },
      { path: 'health/blood-routine', redirect: '/health/workbench' },
      { path: 'health/heart-rate', redirect: '/health/workbench' },
      { path: 'health/screening', redirect: '/health/workbench' },
      { path: 'patient/list', name: 'PatientList', component: () => import('@/views/Patient/index.vue'), meta: { title: '患者列表' } },
      { path: 'patient/detail/:id', name: 'PatientDetail', component: () => import('@/views/Patient/Detail.vue'), meta: { title: '患者详情' } },
      { path: 'patient/health/:id', redirect: (to) => ({ path: '/health/workbench', query: { patientId: to.params.id } }) },
      { path: 'patient/edit/:id?', name: 'PatientEdit', component: () => import('@/views/Patient/Edit.vue'), meta: { title: '编辑患者' } },
      { path: 'patient/tag-group', name: 'TagGroup', component: () => import('@/views/Patient/TagGroup.vue'), meta: { title: '分组标签' } },
      { path: 'patient/family-members', name: 'PatientFamilyMember', component: () => import('@/views/Patient/FamilyMember.vue'), meta: { title: '家庭成员管理' } },
      {
        path: 'followup/workbench',
        name: 'FollowupWorkbench',
        component: () => import('@/views/Followup/FollowupWorkbench.vue'),
        meta: { title: '随访工作台', auraIosShell: true }
      },
      { path: 'followup/plan-template', redirect: '/followup/workbench' },
      { path: 'followup/plan-assignment', redirect: '/followup/workbench' },
      { path: 'followup/task', redirect: '/followup/workbench' },
      { path: 'followup/subscribe-log', name: 'FollowupSubscribeLog', component: () => import('@/views/Followup/SubscribeLog.vue'), meta: { title: '订阅发送日志' } },
      { path: 'doctor/list', name: 'DoctorList', component: () => import('@/views/Doctor/index.vue'), meta: { title: '医生列表' } },
      { path: 'doctor/assistant', name: 'AssistantList', component: () => import('@/views/Doctor/index.vue'), meta: { title: '助理列表' } },
      { path: 'doctor/hospital', name: 'HospitalList', component: () => import('@/views/Doctor/Hospital.vue'), meta: { title: '医院管理' } },
      { path: 'doctor/commission', name: 'CommissionList', component: () => import('@/views/System/Commission.vue'), meta: { title: '卫健委管理' } },
      { path: 'doctor/clinic-room', name: 'ClinicRoomConfig', component: () => import('@/views/System/ClinicRoom.vue'), meta: { title: '我的诊室配置' } },
      { path: 'message/list', name: 'MessageList', component: () => import('@/views/Message/index.vue'), meta: { title: '问诊记录' } },
      { path: 'assess/category', name: 'AssessCategory', component: () => import('@/views/Assess/Category.vue'), meta: { title: '服务分类' } },
      { path: 'assess/service-list', name: 'AssessServiceList', component: () => import('@/views/Assess/ServiceList.vue'), meta: { title: '服务列表' } },
      { path: 'assess/list', name: 'AssessList', component: () => import('@/views/Assess/index.vue'), meta: { title: '服务包管理' } },
      { path: 'assess/order', name: 'OrderList', component: () => import('@/views/Assess/Order.vue'), meta: { title: '订单管理' } },
      { path: 'assess/benefit', name: 'BenefitList', component: () => import('@/views/Assess/Benefit.vue'), meta: { title: '权益管理' } },
      { path: 'assess/benefit-verify', name: 'BenefitVerify', component: () => import('@/views/Assess/BenefitVerify.vue'), meta: { title: '权益核销' } },
      { path: 'assess/shipment', name: 'ShipmentList', component: () => import('@/views/Assess/Shipment.vue'), meta: { title: '发货管理' } },
      { path: 'assess/refund', name: 'RefundList', component: () => import('@/views/Assess/Refund.vue'), meta: { title: '退款管理' } },
      { path: 'assess/refund-restock', name: 'RefundRestock', component: () => import('@/views/Assess/RefundRestock.vue'), meta: { title: '退款库存回补' } },
      { path: 'assess/order-config', name: 'OrderConfig', component: () => import('@/views/Assess/OrderConfig.vue'), meta: { title: '订单失效设置' } },
      { path: 'cost/wallet-list', name: 'CostWalletList', component: () => import('@/views/Cost/WalletList.vue'), meta: { title: '医生钱包列表' } },
      { path: 'cost/wallet', name: 'CostWallet', component: () => import('@/views/Cost/Wallet.vue'), meta: { title: '医生提现管理' } },
      { path: 'cost/consult-fee', name: 'CostConsultFee', component: () => import('@/views/Cost/ConsultFee.vue'), meta: { title: '咨询费配置' } },
      { path: 'cost/product-inventory', name: 'CostProductInventory', component: () => import('@/views/Cost/ProductInventory.vue'), meta: { title: '产品库存管理' } },
      { path: 'cost/supplier', name: 'CostSupplier', component: () => import('@/views/Cost/SupplierManagement.vue'), meta: { title: '供应商管理' } },
      { path: 'cost/exam/fee-config', name: 'CostExamFeeConfig', component: () => import('@/views/Cost/Exam/FeeConfig.vue'), meta: { title: '体检费配置' } },
      { path: 'cost/exam/pay-management', name: 'CostExamPayManagement', component: () => import('@/views/Cost/Exam/PayManagement.vue'), meta: { title: '机构付款管理' } },
      { path: 'cost/exam/accounts', name: 'CostExamAccounts', component: () => import('@/views/Cost/Exam/Accounts.vue'), meta: { title: '机构账户列表' } },
      { path: 'cost/referral-fee', name: 'CostReferralFee', component: () => import('@/views/Cost/ReferralFeeConfig.vue'), meta: { title: '推荐费配置' } },
      { path: 'cost/partner-merge', name: 'CostPartnerMerge', component: () => import('@/views/Cost/PartnerMerge.vue'), meta: { title: '账号合并MVP' } },
      { path: 'cost/user-wallet', name: 'CostUserWallet', component: () => import('@/views/Cost/UserWalletList.vue'), meta: { title: '用户钱包列表' } },
      { path: 'cost/user-withdraw', name: 'CostUserWithdraw', component: () => import('@/views/Cost/UserWithdrawManage.vue'), meta: { title: '用户提现管理' } },
      { path: 'points/rule', name: 'PointsRule', component: () => import('@/views/Points/Rule.vue'), meta: { title: '积分规则配置' } },
      { path: 'points/title', name: 'PointsTitle', component: () => import('@/views/Points/Title.vue'), meta: { title: '称号管理' } },
      { path: 'points/goods', name: 'PointsGoods', component: () => import('@/views/Points/Goods.vue'), meta: { title: '兑换商品管理' } },
      { path: 'points/exchange-order', name: 'PointsExchangeOrder', component: () => import('@/views/Points/ExchangeOrder.vue'), meta: { title: '兑换订单' } },
      { path: 'points/transaction', name: 'PointsTransaction', component: () => import('@/views/Points/Transaction.vue'), meta: { title: '积分流水' } },
      { path: 'ckm/index', name: 'CkmPlatform', component: () => import('@/views/CkmPlatform/index.vue'), meta: { title: '平台首页' } },
      { path: 'ckm/xiaokang', name: 'XiaokangControl', component: () => import('@/views/CkmPlatform/XiaokangControl.vue'), meta: { title: '小康总控台' } },
      { path: 'ckm/health-chat-usage', name: 'HealthChatUsage', component: () => import('@/views/CkmPlatform/HealthChatUsage.vue'), meta: { title: 'AI_chat技能池用量', auraIosShell: true } },
      { path: 'ckm/hermes-library', redirect: '/ckm/aura-library' },
      { path: 'ckm/aura-library', name: 'AuraLibrary', component: () => import('@/views/CkmPlatform/AuraLibrary.vue'), meta: { title: '藏经阁接入', auraIosShell: true } },
      { path: 'ckm/xiaokang/design/:roleKey', name: 'AuraDutyDesignPage', component: () => import('@/views/CkmPlatform/AuraDutyDesignPage.vue'), meta: { title: '掌门工作台', auraIosShell: true } },
      { path: 'ckm/research-config', name: 'CkmResearchConfig', component: () => import('@/views/CkmPlatform/ResearchConfig.vue'), meta: { title: '科研配置' } },
      { path: 'ckm/research-management', name: 'CkmResearchManagement', component: () => import('@/views/CkmPlatform/ResearchManagement.vue'), meta: { title: '科研管理' } },
      { path: 'ckm/research-topic-recycle', name: 'CkmResearchTopicRecycle', component: () => import('@/views/CkmPlatform/ResearchTopicRecycle.vue'), meta: { title: '课题回收站' } },
      { path: 'report/dashboard', name: 'Report', component: () => import('@/views/Report/index.vue'), meta: { title: '统计报表' } },
      { path: 'report/health', name: 'ReportHealth', component: () => import('@/views/Report/Health.vue'), meta: { title: '健康报表' } },
      { path: 'report/followup', name: 'ReportFollowup', component: () => import('@/views/Report/Followup.vue'), meta: { title: '随访报表' } },
      { path: 'report/data-quality', name: 'ReportDataQuality', component: () => import('@/views/Report/DataQuality.vue'), meta: { title: '数据质量' } },
      { path: 'report/sales', name: 'ReportSales', component: () => import('@/views/Report/Sales.vue'), meta: { title: '销售统计' } },
      { path: 'report/order', name: 'ReportOrder', component: () => import('@/views/Report/OrderStats.vue'), meta: { title: '订单统计' } },
      { path: 'device/vendors', name: 'DeviceVendors', component: () => import('@/views/DeviceManagement/Vendors.vue'), meta: { title: '设备管理-厂商管理' } },
      { path: 'device/bindings', name: 'DeviceBindings', component: () => import('@/views/DeviceManagement/Bindings.vue'), meta: { title: '设备管理-设备绑定' } },
      { path: 'device/jobs', name: 'DeviceChannelHealth', component: () => import('@/views/DeviceManagement/ChannelHealth.vue'), meta: { title: '设备管理-通道健康' } },
      { path: 'system/user-company', name: 'SystemUserCompany', component: () => import('@/views/System/UserCompany.vue'), meta: { title: '公司账号' } },
      { path: 'system/user-medical', name: 'SystemUserMedical', component: () => import('@/views/System/UserMedical.vue'), meta: { title: '医疗机构账号' } },
      { path: 'system/role', name: 'SystemRole', component: () => import('@/views/System/Role.vue'), meta: { title: '角色权限' } },
      { path: 'system/dict', name: 'SystemDict', component: () => import('@/views/System/Dict.vue'), meta: { title: '字典配置' } },
      { path: 'system/message-template', name: 'MessageTemplate', component: () => import('@/views/System/MessageTemplate.vue'), meta: { title: '消息模板' } },
      { path: 'system/about-us', name: 'AboutUs', component: () => import('@/views/System/AboutUs.vue'), meta: { title: '关于我们' } },
      { path: 'system/clinic-room', redirect: '/doctor/clinic-room' },
      { path: 'system/version/app', name: 'VersionControlApp', component: () => import('@/views/System/VersionControl.vue'), meta: { title: '版本控制-APP' } },
      { path: 'system/version/miniprogram', name: 'VersionControlMiniProgram', component: () => import('@/views/System/VersionControl.vue'), meta: { title: '版本控制-小程序' } },
      { path: 'system/version/admin', name: 'VersionControlAdmin', component: () => import('@/views/System/VersionControl.vue'), meta: { title: '版本控制-后台' } },
      { path: 'system/log', name: 'SystemLog', component: () => import('@/views/System/Log.vue'), meta: { title: '操作日志' } }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 避免重复导航到当前路由时报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - 心阅智康` : '心阅智康'
  if (to.meta.noAuth) {
    next()
    return
  }
  if (to.meta.requiresAuth && !store.getters.isLoggedIn) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }
  if (to.meta.requiresAuth && to.path !== '/dashboard' && to.path !== '/login') {
    await store.dispatch('auth/fetchPermission')
    const perm = store.state.auth.permission
    const menus = perm?.menus
    if (Array.isArray(menus)) {
      if (menus.length === 0) {
        if (to.path !== '/dashboard' && to.path !== '/login') {
          next({ path: '/dashboard' })
          return
        }
      } else {
        const pathOk = (p) =>
          menus.some(m => p === m || (m !== '/' && p.startsWith(m + '/')))
        const hasLegacyFollowup =
          pathOk('/followup/plan-template') ||
          pathOk('/followup/plan-assignment') ||
          pathOk('/followup/task')
        const allowed =
          pathOk(to.path) ||
          (to.path === '/followup/workbench' && hasLegacyFollowup) ||
          (to.path === '/doctor/clinic-room' && pathOk('/system/clinic-room')) ||
          (to.path === '/ckm/aura-library' || to.path === '/ckm/aura-library' && pathOk('/ckm/xiaokang'))
        if (!allowed) {
          next({ path: '/dashboard' })
          return
        }
      }
    }
  }
  next()
})

router.afterEach((to) => {
  if (typeof document === 'undefined') return
  document.body.classList.remove('duty-ios-shell')
  if (to.meta && to.meta.auraIosShell) {
    document.body.classList.add('aura-ios-shell')
  } else {
    document.body.classList.remove('aura-ios-shell')
  }
})

export default router
